import type { ReactNode } from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@herit-fe/heritage-ui';

export interface InfoTooltipProps {
  /** 툴팁 본문 — 호버/포커스 시 표시. */
  content: ReactNode;
  /** 트리거(아이콘 버튼) a11y 라벨. */
  label?: string;
  className?: string;
  /** 툴팁 박스(TooltipContent) 추가 클래스 — 다항목 안내 등 기본 `max-w-xs` 너비 override 용. */
  contentClassName?: string;
  /** 툴팁 표시 방향(기본 top). 상단 배치(카드 헤더 등)에서 내용이 길면 `bottom` 으로 아래로 편다. */
  side?: 'top' | 'bottom' | 'left' | 'right';
}

/**
 * (i) 정보 아이콘 + 호버 툴팁 — heritage `Tooltip`(base-ui) 합성. 비활성 사유·보조 설명 안내에 사용
 * (예: 개인정보 미동의 시 검색 제한 안내, 이벤트 등급 안내). `TooltipProvider` 를 자체 포함해 단독 배치 가능
 * (앱 루트 의존 X). 트리거가 버튼이라 마우스 호버 + 키보드 포커스 모두로 열린다.
 * 기본 박스는 `max-w-xs`(heritage) — 다항목 안내는 `contentClassName`(예: `max-w-sm`)으로 넓힌다.
 */
export function InfoTooltip({
  content,
  label,
  className,
  contentClassName,
  side,
}: InfoTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger
          aria-label={label}
          className={[
            'inline-flex cursor-help items-center text-muted-foreground hover:text-foreground',
            className,
          ]
            .filter(Boolean)
            .join(' ')}
        >
          <Info className="size-4" />
        </TooltipTrigger>
        <TooltipContent side={side} className={contentClassName}>
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
